module.exports = __webpack_public_path__ + "static/img/manual-31.a6cdc9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-31.png
// module id = afNu
// module chunks = 4